<template>
  <div class="under-maintenance">
		<img src="/static/icons8-maintenance-100.png" alt="Em manutenção" class="maintenance-image">
    <p>O site está em manutenção. Por favor, volte mais tarde.</p>
  </div>
</template>

<script>
export default {
  name: "UnderMaintenance",
};
</script>

<style scoped>
.under-maintenance {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;

  p {
    margin-top: 20px;
    font-size: 1.5em;
    color: #555;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/UnderMaintenance.vue